// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__TFT7p","formControl":"addForm_formControl__nDMwU","list":"addForm_list__Y5CR8","btnWrpper":"addForm_btnWrpper__xYyGa"};